import React from 'react';
import LeftMenu from './Sections/LeftMenu';
import RightMenu from './Sections/RightMenu';
import './Sections/Navbar.css';

function TabBar() {

  return (
    <nav className="menu tabbar" style={{ position: 'fixed', zIndex: 5, width: '100%', bottom:0 }}>      
      <div className="menu__container">
        <div className="menu_left">
          <LeftMenu mode="horizontal" />
        </div>
      </div>
    </nav>
  )
}

export default TabBar